// const DEV_CONFIGURATIONS = {
//     API_BASE_URL: process.env.REACT_APP_API_BASE_URL_DEV,
//     API_BASE_DOMAIN: process.env.REACT_APP_API_BASE_DOMAIN_DEV,
//     API_BASE_SOCKET_DOMAIN: process.env.REACT_APP_API_BASE_SOCKET_DOMAIN_DEV,
//     API_PAYSTACK_BASE_URL: process.env.REACT_APP_PAYSTACK_BASE_URL_DEV,
//     API_PAYSTACK_PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY_DEV,
//     API_PAYSTACK_SECRET_KEY: process.env.REACT_APP_PAYSTACK_SECRET_KEY_DEV,
//     UPLOAD_API_KEY: process.env.REACT_APP_UPLOAD_API_KEY_DEV,
//   FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY_DEV,
//   FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV,
//   FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV,
//   FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV,
//   FIREBASE_MESSAGE_SENDER_ID:
//     process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID_DEV,
//   FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID_DEV,
//   FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_DEV,
// };

// const PROD_CONFIGURATIONS = {

//   API_BASE_URL: process.env.REACT_APP_API_BASE_URL_PROD,
//   API_BASE_DOMAIN: process.env.REACT_APP_API_BASE_DOMAIN_PROD,
//   API_BASE_SOCKET_DOMAIN: process.env.REACT_APP_API_BASE_SOCKET_DOMAIN_PROD,
//   API_PAYSTACK_BASE_URL: process.env.REACT_APP_PAYSTACK_BASE_URL_PROD,
//   API_PAYSTACK_PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY_PROD,
//   API_PAYSTACK_SECRET_KEY: process.env.REACT_APP_PAYSTACK_SECRET_KEY_PROD,
//   UPLOAD_API_KEY: process.env.REACT_APP_UPLOAD_API_KEY_PROD,
//   FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY_PROD,
//   FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD,
//   FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID_PROD,
//   FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD,
//   FIREBASE_MESSAGE_SENDER_ID:
//     process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID_PROD,
//   FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID_PROD,
//   FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PROD,
// };

// const current_env = process.env.REACT_APP_ENV;

// export const CONFIGURATIONS =
//   current_env && current_env === "dev"
//     ? DEV_CONFIGURATIONS
//     : PROD_CONFIGURATIONS;

const CONFIGURATIONS = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  UPLOAD_API_KEY: process.env.REACT_APP_UPLOAD_API_KEY,
  REACT_APP_CLODUFLARE_URL: process.env.REACT_APP_CLODUFLARE_URL
};

export { CONFIGURATIONS };
